import Vue from 'vue';
import dayjs from 'dayjs';

const formatDate = value => {
    return value ? dayjs(value).format('DD/MM/YY') : '';
};

Vue.filter('formatDate', formatDate);
